import { Link } from "supercell-frontend-base/src/components/article/navigation/link";
import { ListArticle } from "supercell-frontend-base/src/components/list/article";

import { getArticleIndex } from "supercell-frontend-base/src/utils/articles/get-article-index";
import { handleThumbnail } from "supercell-frontend-base/src/utils/articles/get-article-thumbnail";
import { isOnEsportsTab } from "supercell-frontend-base/src/utils/articles/is-on-tab";

export const getProps =
    (id: string, isolated: boolean) =>
    ({ articles, globals }) => {
        const newsArticles = articles.filter(isOnEsportsTab);

        const index = getArticleIndex(newsArticles, id);

        const article = newsArticles[index];
        const nextArticle = newsArticles[index - 1];
        const prevArticle = index > -1 && newsArticles[index + 1];

        const prevLinkProps =
            !isolated && prevArticle
                ? {
                      LabelComponent: ListArticle,
                      labelComponentProps: {
                          data: {
                              ...handleThumbnail(prevArticle),
                              listingSize: "small",
                              newUntil: 0,
                              categories: [
                                  { title: globals["globalText.langOlder"] },
                              ],

                              // ListArticle handles navigating to the article
                              // if Link does it too, we'll get a double render
                              disableOnClick: true,
                          },
                      },
                  }
                : undefined;

        const nextLinkProps =
            !isolated && nextArticle
                ? {
                      next: true,
                      LabelComponent: ListArticle,
                      labelComponentProps: {
                          data: {
                              ...handleThumbnail(nextArticle),
                              listingSize: "small",
                              newUntil: 0,
                              categories: [
                                  { title: globals["globalText.langNewer"] },
                              ],

                              // ListArticle handles navigating to the article
                              // if Link does it too, we'll get a double render
                              disableOnClick: true,
                          },
                      },
                  }
                : undefined;

        return {
            article,
            Link,
            prevLinkProps,
            nextLinkProps,
        };
    };
